import { useState, useEffect } from 'react';

export default function PromoBar() {
  const messages = [
    "TÜM siparişlerde ÜCRETSİZ KARGO.",
    "60 GÜNE KADAR ücretsiz ve kolay iade.",
    "PUMA FAM ÜYESİ OL, İLK SİPARİŞİNDE %15 İNDİRİM KAZAN*",
    "Garanti Bonus'a Özel Peşin Fiyatına 6 Taksit",
    "Müşteri Destek Hattı: 0850 755 19 48"
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % messages.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="bg-black text-white text-center py-2 text-sm">
      <div className="container mx-auto px-4">
        {messages[currentIndex]}
      </div>
    </div>
  );
}
